<template lang="pug">
    div(
        id="#app"
    )
        div(
            class="container"
        )

            v-alert(
                type="error"
                border="left"
                class="mb-4"
                dismissible
            ) This is an alert.

            v-alert(
                type="info"
                border="left"
                class="mb-4"
                dismissible
            ) This is an info.

            v-alert(
                type="success"
                border="left"
                class="mb-4"
                dismissible
            ) This is a success.

            v-alert(
                type="warning"
                border="left"
                class="mb-4"
                dismissible
            ) This is a warning.

            v-col(
                cols="12"
                md="4"
                sm="12"
            )
                v-sheet(
                elevation="3"
                class="pa-6"
                )
                    v-text-field(
                        v-model="model"
                        solo
                        single-line
                        clearable
                        :label="'Username'"
                        :hint="'No Special Characters Allowed'"
                        :counter="16"
                    )
                    div.mt-12.text-center Value: {{ model }}

            v-row(justify="center")
                v-subheader Today

                v-expansion-panels(popout)
                    v-expansion-panel(
                        v-for="(message, i) in messages"
                        :key="i"
                        hide-actions
                    )

                        v-expansion-panel-header
                            v-row(
                                align="center"
                                class="spacer"
                                no-gutters
                            )
                                v-col(
                                    cols="4"
                                    sm="2"
                                    md="1"
                                )
                                    v-avatar(
                                        size="36px"
                                    )
                                        img(
                                            v-if="message.avatar"
                                            alt="Avatar"
                                            src="https://avatars0.githubusercontent.com/u/9064066?v=4&s=460"
                                        )
                                        v-icon(
                                            v-else
                                            :color="message.color"
                                            v-text="message.icon"
                                        )

                                v-col(
                                    class="hidden-xs-only"
                                    sm="5"
                                    md="3"
                                )
                                    strong(v-html="message.name")
                                    span(
                                        v-if="message.total"
                                        class="grey--text"
                                    ) &nbsp;({{ message.total }})

                                v-col(
                                    class="text-no-wrap"
                                    cols="5"
                                    sm="3"
                                )

                                    v-chip(
                                        v-if="message.new"
                                        :color="`${message.color} lighten-4`"
                                        class="ml-0"
                                        label
                                        small
                                    ) {{ message.new }} new 

                                    strong(v-html="' ' + message.title")

                                v-col(
                                    v-if="message.excerpt"
                                    class="grey--text text-truncate hidden-sm-and-down"
                                ) &mdash; {{ message.excerpt }}

                        v-expansion-panel-content
                            v-divider
                            v-card-text(v-text="lorem")


</template>

<script>
export default {
	methods: {
		// Force Updates only the component we are calling this function from
		forceUpdate() {
			this.$forceUpdate();
		},
		gotoPage() {
			this.$router.go(this.historyPage);
			this.forceUpdate();
		}
	},
	data() {
		return {
			model: "",
			messages: [
				{
					avatar:
						"https://avatars0.githubusercontent.com/u/9064066?v=4&s=460",
					name: "John Leider",
					title: "Welcome to Vuetify.js!",
					excerpt: "Thank you for joining our community..."
				},
				{
					color: "red",
					icon: "people",
					name: "Social",
					new: 1,
					total: 3,
					title: "Twitter"
				},
				{
					color: "teal",
					icon: "local_offer",
					name: "Promos",
					new: 2,
					total: 4,
					title: "Shop your way",
					exceprt: "New deals available, Join Today"
				}
			],
			lorem:
				"Lorem ipsum dolor sit amet, at aliquam vivendum vel, everti delicatissimi cu eos. Dico iuvaret debitis mel an, et cum zril menandri. Eum in consul legimus accusam. Ea dico abhorreant duo, quo illum minimum incorrupte no, nostro voluptaria sea eu. Suas eligendi ius at, at nemore equidem est. Sed in error hendrerit, in consul constituam cum."
		};
	}
};
</script>